document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;
  e.preventDefault();

  const formData = new FormData(form);
  const res = await fetch('/cart/add.js', { method: 'POST', body: formData });

  if (res.ok) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { data: { itemCount: 1, source: 'product-form-component' } }
    }));
  }
});